import { type SupportedCurrencyCode } from 'types/types';

//show price with decimal separators and with currency symbol
export const currencyHelper = (
  amount: number,
  currency: SupportedCurrencyCode
) => {
  const decimalDigits = amount % 1 > 0 ? 2 : 0;
  let price = amount.toLocaleString('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimalDigits,
    maximumFractionDigits: decimalDigits,
  });

  return price;
};
